import React, { useState } from "react";
import { useGlobalContext } from "../../context/context";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FiKey, FiShield } from "react-icons/fi";

const OTPModal = () => {
  const { userDetails, baseUrl, getUser } = useGlobalContext();
  const { otpMessage, userOtp, transferStep } = userDetails;
  const [otpError, setOtpError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const accessToken = JSON.parse(sessionStorage.getItem("accessToken"));

  const navigate = useNavigate();

  const updateOTPStep = () => {
    setLoading(true);
    axios
      .put(
        `${baseUrl}users/user/${userDetails._id}`,
        { transferStep: transferStep + 1 },
        { headers: { token: accessToken } }
      )
      .then((data) => {
        setLoading(false);
        getUser(accessToken);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const notify = () =>
    toast.success(
      "The OTP check was successful, Please come back in ten minutes time"
    );

  //Check OTP
  const checkOtp = () => {
    if (inputValue !== userOtp) {
      setOtpError(true);
    }
    if (inputValue == userOtp) {
      setOtpError(false);
      updateOTPStep();
      if (!loading) {
        notify();
        setTimeout(() => {
          navigate("/wallet");
        }, 3000);
      }
    }
  };

  return (
    <>
      <div className="otp_modal pg-finance-otp-overlay" role="dialog" aria-modal="true" aria-labelledby="withdraw-verify-title">
        <div>
          <span className="pg-finance-otp-icon"><FiKey size={19} /></span><span className="pg-finance-eyebrow"><FiShield size={12} /> SECURITY CHECK</span>
          <h2 className="pg-finance-otp-title" id="withdraw-verify-title">Verify this request</h2><p className="otp_message">{otpMessage}</p>
          <label htmlFor="withdraw-verification-code">Verification code<input id="withdraw-verification-code" type="text" autoComplete="one-time-code" onChange={(e) => setInputValue(e.target.value)} /></label>
          {otpError && <p className="error" role="alert" style={{ marginTop: "12px" }}>That code did not match. Check it and try again.</p>}
          <button className="btn" type="button" onClick={checkOtp} disabled={loading}>{loading ? "Checking…" : "Confirm code"}</button>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default OTPModal;
